const PROMPT_KEY_PREFIX = 'townViewTutorialPromptDismissed:';
export const TOWN_VIEW_TUTORIAL_REPLAY_EVENT = 'town-view-tutorial-replay';

export const requestTownViewTutorialReplay = () => {
  window.dispatchEvent(new Event(TOWN_VIEW_TUTORIAL_REPLAY_EVENT));
};

export const isTownViewTutorialPromptDismissed = (scopeKey) => {
  if (!scopeKey) return true;
  try {
    return localStorage.getItem(`${PROMPT_KEY_PREFIX}${scopeKey}`) === '1';
  } catch {
    return false;
  }
};

export const dismissTownViewTutorialPrompt = (scopeKey) => {
  if (!scopeKey) return;
  try {
    localStorage.setItem(`${PROMPT_KEY_PREFIX}${scopeKey}`, '1');
  } catch {
    /* ignore quota / private mode */
  }
};
